import {
  Button as ButtonStyle,
  styled,
  Text as DefaultText,
  DropdownMenu,
  FlexRowCenter,
  Icon,
} from "@reside/ui";

// AdmissionMenuDropdownButton
export const Wrapper = styled.div`
  align-items: center;
  display: inline-flex;
  cursor: pointer;
  user-select: none;
`;

export const IconWrapper = styled.div`
  margin-left: 5px;
`;

export const AdminIcon = styled(Icon)<{open: boolean}>`
  color: ${({open, theme}) =>
    open ? theme.color.primary : theme.color.darkBlue100};
  &:hover {
    color: ${({theme}) => theme.color.primary};
  }
`;

// Signout
export const SignOutButton = styled(ButtonStyle)`
  span {
    color: ${({theme}) => theme.color.darkBlue100};
  }

  :is(&:hover, &:focus-within, &:focus) span {
    text-decoration: underline;
  }
`;

export const SignOutText = styled(DefaultText)`
  padding-block: 0.125rem 1rem;
  user-select: none;
  text-align: center;
`;

export const FlexRowJustify = styled(FlexRowCenter)`
  gap: 1rem;
  justify-content: space-between;
`;

/** Avatar-only profile menu control (no caret); opens the menu on click. */
export const ProfileMenuTrigger = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
  color: inherit;

  &:focus-visible {
    outline: 2px solid ${({theme}) => theme.color.primary};
    outline-offset: 2px;
  }

  box-shadow: ${({$active, theme}) =>
    $active ? `0 0 0 2px ${theme.color.primary}40` : "none"};
  transition: box-shadow 0.12s ease;
`;

// User profile dropdown (all breakpoints)
export const ProfileDropdownMenu = styled(DropdownMenu)``;

export const ProfileMenuNameSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px 10px;
  margin-bottom: 4px;
  border-bottom: 1px solid ${({theme}) => theme.color.borderLightGray};
`;

export const ProfileMenuName = styled(DefaultText)`
  display: block;
  font-size: ${({theme}) => theme.fontSize[3]}px;
  font-weight: ${({theme}) => theme.fontWeight.medium};
  color: ${({theme}) => theme.color.darkBlue100};
  line-height: 1.25;
  word-break: break-word;
`;
